import axios from "axios";
import store from "../store/store";
import { authAction } from "../store/authentication";
import { trackUserIntearaction } from "./gaTracker";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Paths that should NOT include credentials (cookies)
const noCredentialPaths = [];

api.interceptors.request.use((config: any) => {
  const url = config?.url || "";

  // Set withCredentials based on path
  const disableCreds = noCredentialPaths.some((path) => url.includes(path));
  config.withCredentials = !disableCreds;
  return config;
});

const errorHandler = (error: any) => {
  const allTrackingInput = store.getState().search.allTrackingInput;
  const statusCode = error.response?.status;
  const apiPath = error?.config?.url;
  const errorMsg =
    error?.errormsg ||
    error?.response?.data?.message ||
    "An unknown error occurred";

  console.log("API called:", apiPath);

  if (statusCode == 401) {
    console.warn("401 Unauthorized - token/session may have expired.");
    store.dispatch(
      authAction.setAuthStatus({ isAuthenticated: false, isConcierge: false })
    );
  }

  if (!apiPath?.includes("track-user")) {
    trackUserIntearaction(
      "User input",
      "search",
      "",
      {
        is_search_success: 0,
        search_failure_message: `${statusCode} ${errorMsg}`,
        ...allTrackingInput,
      },
      false,
      true
    );
  }

  throw error;
};

api.interceptors.response.use((response) => response, errorHandler);

export { api };
